import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { ApiUserSettingsConstants } from "../../shared/constants/api-constants/api-user-settings.constants";
import { HttpClient } from "@angular/common/http";
let MapToolsServiceService = class MapToolsServiceService {
    http;
    constructor(http) {
        this.http = http;
    }
    updateBookmarks(key, bookmarks) {
        const model = {
            value: bookmarks
        };
        return this.http.patch(`${ApiUserSettingsConstants.URL}/${key}`, model);
    }
    createBookmarks(params) {
        return this.http.post(`${ApiUserSettingsConstants.URL}`, params);
    }
    getBookmarks(userId, moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and userId eq ${userId} and key eq 'Bookmarks'`
        };
        return this.http.get(`${ApiUserSettingsConstants.URL}`, { params });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
MapToolsServiceService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MapToolsServiceService);
export { MapToolsServiceService };
